/** Sprint S13.3.A — checkout cancel/abandon recovery. Default export. */
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function BillingCancelPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="mx-auto flex min-h-dvh max-w-md flex-col justify-center px-5 py-10 text-center">
      <h1 className="font-serif text-2xl font-medium text-navy">
        {t("billing.cancel.title")}
      </h1>
      <p className="mt-2 text-[15px] text-taupe">
        {t("billing.cancel.subtitle")}
      </p>
      <button
        type="button"
        onClick={() => navigate("/pricing")}
        className="mt-6 rounded-md bg-amber px-6 py-3 font-bold text-navy-deep hover:bg-amber-dark hover:text-cream-light"
      >
        {t("billing.cancel.try_again")}
      </button>
    </div>
  );
}
